module.exports = require('./merge-change.js');
module.exports.utils = require('./utils.js')
module.exports.methods = require('./methods.js')
